import { bindTanstackQueryOnline, bindVisibilityChange } from './bindings';
import { ConnectivityService } from './connectivity-service';
import { onlineConnectionService } from './online-connection-service';
import { rateLimiterService } from './rate-limiter-service';

export const connectivityService = new ConnectivityService(
  onlineConnectionService,
  rateLimiterService,
);

export function initializeConnectionServices() {
  bindVisibilityChange(onlineConnectionService);
  bindTanstackQueryOnline(connectivityService);
}
